import { useState } from 'react'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { CompetencyGroupsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { CompetencyGroupsDataCollection } from './CompetencyGroupsDataCollection'
import { NewCompetencyGroupModal } from './NewCompetencyGroupModal'

const CompetenciesGroups = () => {
  const [showNewCompetencyGroupModal, setShowNewCompetencyGroupModal] = useState(false)

  const { data, loading } = useQuery(CompetencyGroupsDocument)

  const competencyGroupsManage = data?.competencies?._policies?.competencyGroupsManage?.can ?? false

  if (loading) {
    return (
      <Box height="full" padding="s24" justifyContent="center" alignItems="center">
        <Spinner />
      </Box>
    )
  }

  return (
    <ResponsivePage.Body showHeader={false}>
      <CompetencyGroupsDataCollection
        canManageCompetencies={competencyGroupsManage}
        onNewCompetencyGroup={() => setShowNewCompetencyGroupModal(true)}
      />

      {showNewCompetencyGroupModal && (
        <NewCompetencyGroupModal onClose={() => setShowNewCompetencyGroupModal(false)} />
      )}
    </ResponsivePage.Body>
  )
}

export default CompetenciesGroups
